import * as React from "react";
import { SubNav } from "..";
import { isBasicView } from "../../../../utilities/access";

function UserNavigation({ accessLevel, ...rest }) {
  let items = [
    {
      isAvailable: true,
      label: "My Profile",
      path: "/Portal/user/profile",
    },
    {
      isAvailable: true,
      label: "Advisor Settings",
      path: "/Portal/user/advisorSettings",
    },
  ];

  if (!isBasicView(accessLevel)) {
    items.push(
      {
        isAvailable: true,
        label: "Custodians",
        path: "/Portal/user/custodians",
      },
      {
        isAvailable: true,
        label: "My Rep Codes",
        path: "/Portal/user/repCodes",
      }
    );
  }
  return <SubNav items={items} {...rest} />;
}

export default UserNavigation;



// WEBPACK FOOTER //
// ./src/containers/Cy/components/UserNavigation/index.jsx